// frontend/src/components/detail/LockedScopeBanner.jsx
import React from 'react';
import { Alert, Stack, Chip } from '@mui/material';

export default function LockedScopeBanner({ label = 'Locked to Job', value }) {
  if (!value) return null;
  return (
    <Alert
      severity="info"
      icon={false}
      sx={{ mt: 2, mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <strong>{label}:</strong>
        <Chip size="small" label={value} />
      </Stack>
    </Alert>
  );
}
